import { fetchRequest } from 'src/hooks/useAPIRequest'
import { API_ENDPOINTS } from 'src/routes/routes'

import { UserInfo } from '../../types'

const getUserInfo = async () => {
    return await fetchRequest<UserInfo>(API_ENDPOINTS.USER_INFO)
}

export default getUserInfo
